<template>
    <div class="h-screen flex flex-col bg-gray-200">
        <header
            class="bg-gray-50 border-b border-b-gray-200 flex flex-row justify-between gap-x-4 px-4 pt-2 pb-1 min-h-21.5"
        >
            <div class="min-w-48 max-w-96 self-center">
                <slot name="title" />
            </div>

            <div v-if="slots.controls && props.showControls" class="flex flex-row items-stretch flex-1 gap-x-4">
                <div class="w-px -mt-2 -mb-1 bg-gray-200" />

                <div class="flex flex-row items-end grow">
                    <slot name="controls" />
                </div>

                <div class="w-px -mt-2 -mb-1 bg-gray-200" />
            </div>

            <LinkButton
                class="self-center shrink-0"
                size="Base"
                variant="Transparent-Light"
                :to="props.closeTarget"
                :icon-description="props.closeDescription"
            >
                <template #icon>
                    <CloseIcon class="size-5" />
                </template>
            </LinkButton>
        </header>

        <!-- Full-bleed: the body is expected to fill the space, so anything needing
             breathing room brings its own margin. -->
        <main class="flex-1 min-h-0 flex flex-col overflow-hidden bg-gray-50">
            <slot name="body" />
        </main>
    </div>
</template>

<script setup lang="ts">
import LinkButton from '@/components/Button/LinkButton.vue';
import CloseIcon from '@/components/Icon/CloseIcon.vue';
import { useSlots } from 'vue';
import { RouteLocationRaw } from 'vue-router';

type EditTimelineLayoutProps = {
    closeTarget: RouteLocationRaw;
    closeDescription: string;
    // Hides the controls and their separators while the page has nothing to put there yet.
    // The bar keeps its height either way, so it doesn't resize once the controls appear.
    showControls: boolean;
};

const props = defineProps<EditTimelineLayoutProps>();

const slots = useSlots();
</script>
